import React from "react";
import CountryData from "./country_data.json";

export default function CountryFlag({ country_name, style }) {
  const data = CountryData;
  return country_name ? (
    <img
      alt={"flag"}
      src={data.find((o) => o.country === country_name)?.flag}
      style={style ?? { width: 20, marginRight: 5 }}
    ></img>
  ) : null;
}
